/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Template_TitleInputs */

const en_analytics_template_title = /** @type {(inputs: Analytics_Template_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template Comparison`)
};

const de_analytics_template_title = /** @type {(inputs: Analytics_Template_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlagenvergleich`)
};

const fr_analytics_template_title = /** @type {(inputs: Analytics_Template_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparaison des modèles`)
};

const es_analytics_template_title = /** @type {(inputs: Analytics_Template_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparación de plantillas`)
};

const it_analytics_template_title = /** @type {(inputs: Analytics_Template_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confronto modelli`)
};

const nl_analytics_template_title = /** @type {(inputs: Analytics_Template_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sjabloonvergelijking`)
};

const pl_analytics_template_title = /** @type {(inputs: Analytics_Template_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porównanie szablonów`)
};

const fi_analytics_template_title = /** @type {(inputs: Analytics_Template_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mallien vertailu`)
};

const da_analytics_template_title = /** @type {(inputs: Analytics_Template_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skabelonsammenligning`)
};

const sv_analytics_template_title = /** @type {(inputs: Analytics_Template_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Malljämförelse`)
};

/**
* | output |
* | --- |
* | "Template Comparison" |
*
* @param {Analytics_Template_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_template_title = /** @type {((inputs?: Analytics_Template_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Template_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_template_title(inputs)
	if (locale === "fr") return fr_analytics_template_title(inputs)
	if (locale === "es") return es_analytics_template_title(inputs)
	if (locale === "it") return it_analytics_template_title(inputs)
	if (locale === "nl") return nl_analytics_template_title(inputs)
	if (locale === "pl") return pl_analytics_template_title(inputs)
	if (locale === "fi") return fi_analytics_template_title(inputs)
	if (locale === "da") return da_analytics_template_title(inputs)
	if (locale === "sv") return sv_analytics_template_title(inputs)
	return en_analytics_template_title(inputs)
});